import React from 'react';
import { AlertCircleIcon, InfoIcon, CheckCircleIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
type CalloutType = 'info' | 'alert' | 'success' | 'stat' | 'highlight';
interface StyledCalloutProps {
  type: CalloutType;
  children: ReactNode;
  title?: string;
}
export function StyledCallout({
  type,
  children,
  title
}: StyledCalloutProps) {
  const getIcon = () => {
    switch (type) {
      case 'info':
        return <InfoIcon className="h-5 w-5 text-blue-600" data-id="element-264" />;
      case 'alert':
        return <AlertCircleIcon className="h-5 w-5 text-red-600" data-id="element-265" />;
      case 'success':
        return <CheckCircleIcon className="h-5 w-5 text-green-600" data-id="element-266" />;
      case 'stat':
        return <TrendingUpIcon className="h-5 w-5 text-purple-600" data-id="element-267" />;
      case 'highlight':
        return <ZapIcon className="h-5 w-5 text-amber-600" data-id="element-268" />;
    }
  };
  const getStyles = () => {
    switch (type) {
      case 'info':
        return 'bg-blue-50 border-l-4 border-blue-500';
      case 'alert':
        return 'bg-red-50 border-l-4 border-red-500';
      case 'success':
        return 'bg-green-50 border-l-4 border-green-500';
      case 'stat':
        return 'bg-purple-50 border-l-4 border-purple-500';
      case 'highlight':
        return 'bg-amber-50 border-l-4 border-amber-500';
    }
  };
  return <div className={`${getStyles()} p-4 my-4 rounded-r`} data-id="element-269">
      <div className="flex items-start" data-id="element-270">
        <div className="flex-shrink-0 mt-0.5 mr-3" data-id="element-271">{getIcon()}</div>
        <div data-id="element-272">
          {title && <h4 className="font-bold text-base mb-1" data-id="element-273">{title}</h4>}
          <div className="text-sm" data-id="element-274">{children}</div>
        </div>
      </div>
    </div>;
}